import script from "./WritingBoard.vue?vue&type=script&lang=ts&setup=true"
export * from "./WritingBoard.vue?vue&type=script&lang=ts&setup=true"

import "./WritingBoard.vue?vue&type=style&index=0&id=1a485ba7&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a485ba7"]])

export default __exports__